/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/boat'
export default icon
